import { APIClient } from "../../helpers/api_helper";
const AxiosClient = new APIClient();

const getAllChangeRequest = (params) => AxiosClient.get('/change-request', { ...params });
const changeRequestCreate = (payload) =>
  AxiosClient.post("/change-request", payload);
const changeRequestStatusUpdate = (changeRequest, payload) =>
  AxiosClient.put(`/change-request/${changeRequest}/status`, { ...payload });
const getChangeRequestDetails = (params, query) => AxiosClient.get(`/change-request/${params}`, query);
const changeRequestUpdate = (id,payload) =>
  AxiosClient.put(`/change-request/${id}`, payload);
const getAllChangeRequestActivities = (params) => AxiosClient.get('/change-request-activity', { ...params });

export { getAllChangeRequest, changeRequestCreate, changeRequestStatusUpdate, getChangeRequestDetails, changeRequestUpdate, getAllChangeRequestActivities };